<template>
  <div>
    <div
      v-for="(section, index) in sections"
      class="accordion-header"
      :class="headerClass"
      :key="'faq-' + index"
      :data-faq-id="'faq_' + index"
    >
      <div
        class="flex items-center py-4 justify-between group cursor-pointer"
        @click="toggleSection(index, section)"
        :ref="`section-header-${index}`"
      >
        <p class="ds-text-base font-medium pl-3" v-html="section.label"></p>

        <i
          class="px-3 text-xl sr-2 sr-v2-minus"
          v-if="isSectionActive(index, section)"
        ></i>
        <i class="px-3 text-xl sr-2 sr-v2-plus" v-else></i>
      </div>

      <div
        class="font-normal ds-text-base accordion-content px-3"
        :class="{ active: isSectionActive(index, section) }"
        :ref="`section-content-${index}`"
      >
        <div class="mb-4" v-html="section.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array | Number | String,
    sections: {
      type: Array,
      required: true,
    },
    allowMultipleOpen: {
      type: Boolean,
      default: true,
    },
    headerClass: String,
  },
  data() {
    return {};
  },
  computed: {
    interface: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    toggleSection(index, section) {
      if (this.isSectionActive(index, section)) {
        this.$delete(this.interface, this.interface.indexOf(index));
      } else {
        let active = this.interface ? this.interface : [];

        active.push(index);

        this.interface = active;

        this.$emit("sectionOpened", index);
      }

      this.$nextTick(() => {
        let content = this.$refs[`section-content-${index}`][0];

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    },
    isSectionActive(index, section) {
      if (this.interface && typeof this.interface === "object") {
        return this.interface.indexOf(index) >= 0;
      }

      return false;
    },
    bindResize() {
      window.addEventListener('resize', e => {
        this.$nextTick(() => {
          this.sections.forEach((section, index) => {
            if (this.isSectionActive(index)) {
              let content = this.$refs[`section-content-${index}`][0];
  
              content.style.maxHeight = `${content.scrollHeight}px`;
            }
          });
        });
      });
    },
  },
  mounted() {
    this.bindResize();
  }
};
</script>

<style scoped>
.accordion-header:first-child {
  border-top: solid 1px;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.2s ease-out;
  transition: max-height 0.2s ease-out;
}
</style>
